export default __webpack_public_path__ + "static/media/Rectangle-2.e50d5dad.png";